import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { PrivateDoctorActions } from 'applicaiton/constants/actions';
import { PrivateDoctorAPI } from 'integration/api/privateDoctor';
import { PrivateDoctorUpdateParams } from 'common/types/privateDoctor';

/**
 * This function is used to fetch a private doctor's details based on their ID.
 *
 * @param id - The unique identifier for the private doctor whose details are required.
 * @returns An object containing the fetched data or an error message if the request fails.
 */
export const getPrivateDoctor = createAsyncThunk(
  PrivateDoctorActions.getPrivateDoctor,
  async (id: string, { rejectWithValue }) => {
    try {
      const { data: responseData } = await PrivateDoctorAPI.getPrivateDoctor(
        id,
      );
      return responseData;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);

/**
 * This function is used to update a private doctor's details.
 *
 * @param params - An object containing the updated data for the private doctor.
 * @returns An object containing the updated data or an error message if the request fails.
 */
export const updatePrivateDoctor = createAsyncThunk(
  PrivateDoctorActions.updatePrivateDoctor,
  async (params: PrivateDoctorUpdateParams, { rejectWithValue }) => {
    try {
      const { data } = await PrivateDoctorAPI.updatePrivateDoctor(params);
      return data;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);
